var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fill-height":"","fluid":""}},[_c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('v-col',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.iframeUrl,"width":"100%","height":"100%"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }